var _path, _mask, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMembershipPrimary(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 17C13.866 17 17 13.866 17 10C17 6.13401 13.866 3 10 3C6.13401 3 3 6.13401 3 10C3 13.866 6.13401 17 10 17ZM10 19C14.9706 19 19 14.9706 19 10C19 5.02944 14.9706 1 10 1C5.02944 1 1 5.02944 1 10C1 14.9706 5.02944 19 10 19Z",
    fill: "#58B6A8"
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-2-inside-1_49_40497",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19 10C19 12.3446 18.1035 14.4798 16.6345 16.0815C15.7009 13.7086 13.0832 12 10 12C6.91676 12 4.2991 13.7086 3.36549 16.0815C1.89654 14.4798 1 12.3446 1 10C1 5.02944 5.02944 1 10 1C14.9706 1 19 5.02944 19 10ZM10 10C11.6569 10 13 8.65685 13 7C13 5.34315 11.6569 4 10 4C8.34315 4 7 5.34315 7 7C7 8.65685 8.34315 10 10 10Z"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19 10C19 12.3446 18.1035 14.4798 16.6345 16.0815C15.7009 13.7086 13.0832 12 10 12C6.91676 12 4.2991 13.7086 3.36549 16.0815C1.89654 14.4798 1 12.3446 1 10C1 5.02944 5.02944 1 10 1C14.9706 1 19 5.02944 19 10ZM10 10C11.6569 10 13 8.65685 13 7C13 5.34315 11.6569 4 10 4C8.34315 4 7 5.34315 7 7C7 8.65685 8.34315 10 10 10Z",
    fill: "#58B6A8"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.6345 16.0815L15.7039 16.4476L16.2899 17.9367L17.3715 16.7574L16.6345 16.0815ZM3.36549 16.0815L2.62851 16.7574L3.71015 17.9367L4.29606 16.4476L3.36549 16.0815ZM17.3715 16.7574C19.003 14.9785 20 12.6045 20 10H18C18 12.0846 17.204 13.9811 15.8975 15.4056L17.3715 16.7574ZM10 13C12.7366 13 14.9431 14.5138 15.7039 16.4476L17.5651 15.7153C16.4587 12.9035 13.4299 11 10 11V13ZM4.29606 16.4476C5.05693 14.5138 7.26338 13 10 13V11C6.57014 11 3.54126 12.9035 2.43493 15.7153L4.29606 16.4476ZM0 10C0 12.6045 0.99704 14.9785 2.62851 16.7574L4.10247 15.4056C2.79604 13.9811 2 12.0846 2 10H0ZM10 0C4.47715 0 0 4.47715 0 10H2C2 5.58172 5.58172 2 10 2V0ZM20 10C20 4.47715 15.5228 0 10 0V2C14.4183 2 18 5.58172 18 10H20ZM12 7C12 8.10457 11.1046 9 10 9V11C12.2091 11 14 9.20914 14 7H12ZM10 5C11.1046 5 12 5.89543 12 7H14C14 4.79086 12.2091 3 10 3V5ZM8 7C8 5.89543 8.89543 5 10 5V3C7.79086 3 6 4.79086 6 7H8ZM10 9C8.89543 9 8 8.10457 8 7H6C6 9.20914 7.79086 11 10 11V9Z",
    fill: "#58B6A8",
    mask: "url(#path-2-inside-1_49_40497)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMembershipPrimary);
export default __webpack_public_path__ + "static/media/membership_primary.b4448418.svg";
export { ForwardRef as ReactComponent };